import React from "react";
import SEO from "@/components/SEO";

export default function TermsPage() {
  return (
    <>
      <SEO
        title="Terms of Service"
        description="Bill Forge Terms of Service. Read our terms and conditions for using our invoicing software. Understand your rights and responsibilities when using Bill Forge."
        path="/terms"
      />
      <div className="bg-background">
      <section className="py-20 bg-gradient-to-b from-primary/5 to-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            Terms of Service
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </section>

      <section className="py-20 bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-card border border-border rounded-2xl p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2 className="text-2xl font-bold font-manrope mb-4">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground mb-6">
                By accessing and using Bill Forge, you accept and agree to be bound by the terms
                and provisions of this agreement.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">2. User Accounts</h2>
              <p className="text-muted-foreground mb-6">
                You are responsible for maintaining the confidentiality of your account and
                password. You agree to accept responsibility for all activities that occur under
                your account.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">3. Services</h2>
              <p className="text-muted-foreground mb-6">
                Bill Forge provides invoicing, customer management, and inventory tracking
                services. We reserve the right to modify, suspend, or discontinue any aspect of
                the service at any time.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">4. Payment Terms</h2>
              <p className="text-muted-foreground mb-6">
                Subscription fees are charged in advance on a recurring basis. All fees are
                non-refundable except as required by law.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">5. Privacy Policy</h2>
              <p className="text-muted-foreground mb-6">
                Your use of Bill Forge is also governed by our Privacy Policy, which can be found
                in the footer of our website.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">6. Limitation of Liability</h2>
              <p className="text-muted-foreground mb-6">
                Bill Forge shall not be liable for any indirect, incidental, special, or
                consequential damages resulting from the use or inability to use the service.
              </p>

              <h2 className="text-2xl font-bold font-manrope mb-4">7. Contact</h2>
              <p className="text-muted-foreground">
                For questions about these Terms of Service, please contact us at
                info@codingwithdevam.cloud
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
